import { Link } from '@tanstack/react-router';
import { Trans } from '@lingui/react/macro';
import { Compass } from 'lucide-react';
import { Button } from '@/components/ui/button';

/**
 * Router `defaultNotFoundComponent` — shown for an unmatched URL or a route that
 * throws `notFound()`. Mirrors the homepage empty-state treatment so an unknown
 * path lands somewhere on-brand with a single way back.
 */
export function NotFound() {
  return (
    <div className='flex min-h-[60vh] flex-col items-center justify-center gap-4 px-6 text-center'>
      <div className='bg-muted text-muted-foreground flex size-12 items-center justify-center rounded-full'>
        <Compass className='size-6' />
      </div>
      <div className='space-y-1'>
        <h2 className='text-lg font-semibold tracking-tight'>
          <Trans>Page not found</Trans>
        </h2>
        <p className='text-muted-foreground max-w-sm text-sm'>
          <Trans>The page you are looking for does not exist or has moved.</Trans>
        </p>
      </div>
      <Button variant='outline' nativeButton={false} render={<Link to='/' />}>
        <Trans>Go to homepage</Trans>
      </Button>
    </div>
  );
}
